<template>
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13.5" cy="13.5" r="12.5" stroke-width="2" />
    <path
      fill="currentColor"
      d="M17.9998 13.9838C17.9974 13.6479 17.876 13.3263 17.6615 13.0869L12.0128 6.88108C11.7924 6.63784 11.493 6.50077 11.1806 6.5C10.8682 6.49924 10.5683 6.63486 10.3469 6.87703C10.1255 7.11919 10.0007 7.44807 10 7.7913C9.99931 8.13454 10.1228 8.46402 10.3432 8.70726L15.1608 14L10.3432 19.2927C10.1228 19.536 9.99931 19.8655 10 20.2087C10.0007 20.5519 10.1255 20.8808 10.3469 21.123C10.5683 21.3651 10.8682 21.5008 11.1806 21.5C11.493 21.4992 11.7924 21.3622 12.0128 21.1189L17.6615 14.9131C17.7713 14.7907 17.8577 14.6454 17.9158 14.4859C17.9739 14.3263 18.0025 14.1557 17.9998 13.9838Z"
    />
  </svg>
</template>
